import { GtmEvents } from '@/gtm/gtm-events';

export class CatalogGtmEvents extends GtmEvents {
  eventCategory = 'СобытияВКаталоге';

  viewCatalogPage({ cityName, categoryId, products = [] }) {
    const productsIds = products.map(({ id }) => id);

    this.gtmEvent({
      eventAction: 'Каталог_ПросмотрСтраницы',
      eventLabel: cityName,
      params: {
        categoryId,
      }
    });

    this.crtoEvent('crto_listingpage', {
      products: productsIds,
    });
  }

  clickMenuItem({ oldPath = [], newPath = [] }) {
    return this.gtmEvent({
      eventAction: 'Каталог_КликПоМенюКаталога',
      eventLabel: `${oldPath.join(' / ')} | ${newPath.join(' / ')}`,
    });
  }
}

export const catalogGtmEvents = new CatalogGtmEvents();
